<ng-template #defaultHeaderTemplate>
    <div class="d-flex justify-content-end psic-pt-6 psic-px-6 psic-mb-5">
        <div class="d-flex w-73 justify-content-end psic-gap-4">
            <div class="vr"></div>
            <mat-icon
                class="filter-nav__container__top-close mat-icon-24 pointerCursor"
                [svgIcon]="'close'"
                (click)="onClose()">
            </mat-icon>
        </div>
    </div>
</ng-template>

<ng-template #defaultTotalTemplate> </ng-template>

<ng-template #defaultFooterTemplate>
    <lib-button
        (callback)="onCancel()"
        [buttonSize]="'large'"
        [disabled]="false"
        [buttonTheme]="'primary'"
        [buttonType]="'borderless'"
        [buttonText]="'Cancel'"
    >
    </lib-button>
    <lib-button (callback)="onSave()" [disabled]="!form.valid" [buttonTheme]="'primary'" [buttonText]="'Save'">
    </lib-button>
</ng-template>

<ng-template #defaultContentTemplate> </ng-template>

<div class="d-flex flex-column add-note-panel" style="position: relative; overflow: hidden; height: 100dvh">
    <!--header-->
    <div>
        <ng-container
            [ngTemplateOutlet]="headerTemplate || defaultHeaderTemplate"
            [ngTemplateOutletContext]="{ data: data }"
        ></ng-container>
    </div>

    <!--content-->
    <mat-dialog-content class="psic-gap-2">
        <ng-container
            [ngTemplateOutlet]="contentTemplate || defaultContentTemplate"
            [ngTemplateOutletContext]="{ data: data }"
        ></ng-container>
    </mat-dialog-content>

    <!--total-->
    @if (totalTemplate) {
    <ng-container [ngTemplateOutlet]="totalTemplate" [ngTemplateOutletContext]="{ data: data }"> </ng-container>
    }

    <!--footer-->
    <div class="d-flex position-relative mt-auto psic-gap-7 psic-p-4 align-items-center justify-content-end">
        <ng-container
            [ngTemplateOutlet]="footerTemplate || defaultFooterTemplate"
            [ngTemplateOutletContext]="{ data: data }"
        ></ng-container>
    </div>

    @if (loading$ | async; as loading) { @if (loading) {
    <div style="position: absolute; left: 0; right: 0; top: 0; bottom: 0; background: black; opacity: 0.2"></div>
    } }
</div>
